import React, { useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import "./TaskAssignPage.css";

const TaskAssignPage = () => {
  const [companies, setCompanies] = useState([]); // Companies list
  const [staffMembers, setStaffMembers] = useState([]); // Staff members list
  const [tasks, setTasks] = useState([]); // Task list
  const [selectedCompany, setSelectedCompany] = useState(null); // Selected company
  const [selectedType, setSelectedType] = useState(""); // Selected task type
  const [selectedStaff, setSelectedStaff] = useState(null); // Selected staff member
  const [selectedTasks, setSelectedTasks] = useState([]); // Selected task IDs
  const [message, setMessage] = useState(""); // Status message
  const [selectedServer, setSelectedServer] = useState("");
  const [servers, setServers] = useState([]);
  

  useEffect(() => {
    const fetchServers = async () => {
      try {
        const response = await axios.get("https://astrovidhya.in/api/servers");
  
        if (response.data && Array.isArray(response.data)) {
          setServers(response.data.map(server => ({
            _id: server._id,
            serverName: server.serverName // ✅ Ensure correct field mapping
          })));
        } else {
          console.error("Invalid server data:", response.data);
          setServers([]); // Ensure an empty array if the response is incorrect
        }
      } catch (error) {
        console.error("Error fetching servers:", error);
        setServers([]);
      }
    };
  
    fetchServers();
  }, []);
  
  
  
  // Fetch companies and staff members on load
  useEffect(() => {
    const fetchData = async () => {
      try {
        const companyResponse = await axios.get("https://astrovidhya.in/api/companies");
        const staffResponse = await axios.get("https://astrovidhya.in/api/staff");
        setCompanies(companyResponse.data.map((c) => ({ value: c.name, label: c.name })));
        setStaffMembers(staffResponse.data.map((s) => ({ value: s._id, label: s.name })));
      } catch (error) {
        console.error("Error fetching data:", error);
        setMessage("Failed to fetch data.");
      }
    };
    fetchData();
  }, []);

  // Fetch tasks based on the selected company
  const handleSearch = async () => {
    if (!selectedServer) {
      setMessage("Please select a server.");
      return;
    }
  
    try {
      const response = await axios.get("https://astrovidhya.in/api/customers", {
        params: { server: selectedServer }, // ✅ Corrected: Fetch tasks by `server`, not `company`
      });
      setTasks(response.data.customers);
      setMessage("Tasks loaded successfully.");
    } catch (error) {
      console.error("Error fetching tasks:", error);
      setMessage("Failed to fetch tasks.");
    }
  };
  

  // Assign tasks to a staff member with a selected type
  const assignTasks = async () => {
    if (!selectedStaff || selectedTasks.length === 0 || !selectedType) {
      setMessage("Please select tasks, a staff member, and a task type.");
      return;
    }

    try {
      await axios.post("https://astrovidhya.in/api/assign-tasks", {
        tasks: selectedTasks, // List of selected task IDs
        staff: selectedStaff.value, // Staff member ID
        type: selectedType, // Order or Subscription
      });
      setMessage("Tasks assigned successfully.");
      handleSearch(); // Refresh the task list
    } catch (error) {
      console.error("Error assigning tasks:", error);
      setMessage("Failed to assign tasks.");
    }
  };

  // Handle checkbox selection
  const handleCheckboxChange = (taskId) => {
    setSelectedTasks((prev) =>
      prev.includes(taskId)
        ? prev.filter((id) => id !== taskId)
        : [...prev, taskId]
    );
  };

  return (
    <div className="task-assign-page px-12 pt-12">
      <h2 className="text-2xl font-bold mb-6">Assign Task</h2>

      {/* Top Panel */}
      <div className="bg-white p-6 rounded-lg shadow-md mb-6">
        {/* Company Dropdown */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium mb-2">Select Server</label>
          <select
  value={selectedServer}
  onChange={(e) => setSelectedServer(e.target.value)}
>
  <option value="">Select a Server</option>
  {servers.map((server) => (
    <option key={server._id} value={server.serverName}> {/* ✅ Corrected from server.name to server.serverName */}
      {server.serverName} {/* ✅ Display correct server name */}
    </option>
  ))}
</select>


        </div>

        {/* Staff Dropdown */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium mb-2">Select Staff Member</label>
          <Select
            options={staffMembers}
            value={selectedStaff}
            onChange={setSelectedStaff}
            placeholder="Select a Staff Member"
          />
        </div>

        {/* Radio Buttons */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium mb-2">Task Type</label>
          <div className="flex gap-4">
            <label className="inline-flex items-center">
              <input
                type="radio"
                value="Order"
                checked={selectedType === "Order"}
                onChange={(e) => setSelectedType(e.target.value)}
                className="form-radio accent-[#03C9D7] text-blue-500"
              />
              <span className="ml-2">Order</span>
            </label>
            <label className="inline-flex items-center">
              <input
                type="radio"
                value="Subscription"
                checked={selectedType === "Subscription"}
                onChange={(e) => setSelectedType(e.target.value)}
                className="form-radio accent-[#03C9D7] text-blue-500"
              />
              <span className="ml-2">Subscription</span>
            </label>
          </div>
        </div>

        {/* Buttons */}
        <div className="flex gap-4">
          <button
            onClick={handleSearch}
            className="bg-[#03c9d7] hover:bg-[#02A5B3] text-white px-4 py-2 rounded-lg w-1/6"
          >
            Search
          </button>
          <button
            onClick={assignTasks}
            className="bg-[#028ca3] hover:bg-[#02A5B3] text-white px-4 py-2 rounded-lg w-1/6"
          >
            Assign Tasks
          </button>
        </div>
      </div>

      {/* Task List */}
      <div className="bg-white p-6 rounded-lg shadow-md">
        <h3 className="text-xl font-semibold mb-4">Task List</h3>
        <table className="w-full border-collapse border border-gray-300">
          <thead>
            <tr className="bg-gray-100">
              <th className="border accent-[#03C9D7] border-gray-300 px-4 py-2">
                <input
                  type="checkbox"
                  onChange={(e) =>
                    setSelectedTasks(
                      e.target.checked ? tasks.map((t) => t._id) : []
                    )
                  }
                />
              </th>
              <th className="border border-gray-300 px-4 py-2">Date</th>
              <th className="border border-gray-300 px-4 py-2">Name</th>
              <th className="border border-gray-300 px-4 py-2">Address</th>
              <th className="border border-gray-300 px-4 py-2">Mobile No</th>
              <th className="border border-gray-300 px-4 py-2">Pincode</th>
              <th className="border border-gray-300 px-4 py-2">Product</th>
              <th className="border border-gray-300 px-4 py-2">Pay Mode</th>
            </tr>
          </thead>
          <tbody>
            {tasks.map((task) => (
              <tr key={task._id} className="hover:bg-gray-100">
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    type="checkbox"
                    checked={selectedTasks.includes(task._id)}
                    onChange={() => handleCheckboxChange(task._id)}
                  />
                </td>
                <td className="border border-gray-300 px-4 py-2">{task.date}</td>
                <td className="border border-gray-300 px-4 py-2">{task.name}</td>
                <td className="border border-gray-300 px-4 py-2">{task.address}</td>
                <td className="border border-gray-300 px-4 py-2">{task.mobile}</td>
                <td className="border border-gray-300 px-4 py-2">{task.pincode}</td>
                <td className="border border-gray-300 px-4 py-2">{task.product}</td>
                <td className="border border-gray-300 px-4 py-2">{task.payMode}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {message && <p className="mt-4 text-center text-green-600 font-medium">{message}</p>}
    </div>
  );
};

export default TaskAssignPage;
